/** An existing server as the rest of the flow reads it. */
import type { ExistingServerSummary, ExistingSqlServer } from '@/types/infrastructure'

/** The DB server as the flow reads it. Its instances are not looked up on the AppCentral level, so it has none. */
export function asSqlServer(server: ExistingServerSummary): ExistingSqlServer {
  return { name: server.name, resourceGroup: server.resourceGroup, image: server.image, vnet: server.vnet, subnet: server.subnet, instances: [] }
}

interface DetailRow {
  label: string
  value: string
  mono?: boolean
}

/** The read-only details of an existing RDS server. */
export const rdsServerDetails = (server: ExistingServerSummary, regionLabel: string): DetailRow[] => [
  { label: 'Name', value: server.name, mono: true },
  { label: 'Resource group', value: server.resourceGroup, mono: true },
  { label: 'Region', value: regionLabel || server.region },
  { label: 'Image', value: server.image },
  { label: 'VNet / subnet', value: `${server.vnet} / ${server.subnet}`, mono: true },
  ...(server.ip ? [{ label: 'IP address', value: server.ip, mono: true }] : []),
]

/** The read-only details of an existing DB server. The AppCentral level does not look up its instances, so it does not count them. */
export const dbServerDetails = (server: ExistingSqlServer, withInstances: boolean): DetailRow[] => [
  { label: 'Name', value: server.name, mono: true },
  { label: 'Resource group', value: server.resourceGroup, mono: true },
  { label: 'Image', value: server.image },
  { label: 'VNet / subnet', value: `${server.vnet} / ${server.subnet}`, mono: true },
  ...(withInstances ? [{ label: 'Named instances', value: String(server.instances.length) }] : []),
]
